import { isPersonalPageSubtype, parseArchivePersonalPageType } from '../subtypes';
import type { PersonalPageSubtype } from '../subtypes';

export function resolveChoiceSubtype(
  choiceSubtype: PersonalPageSubtype,
  registrationType?: 'form' | 'tickets'
): PersonalPageSubtype {
  if (registrationType === undefined) {
    return choiceSubtype;
  }
  if (choiceSubtype === 'choiceDonation') {
    return registrationType === 'tickets' ? 'focusedDonation' : 'partnershipCampaign';
  }
  if (choiceSubtype === 'choiceEvent') {
    return registrationType === 'tickets' ? 'ticketSales' : 'freeEventRegistration';
  }
  return choiceSubtype;
}

export type ResolveTemplateSubtypeArchiveInput = {
  personalPageType?: string;
  archiveType?: string;
};

export function resolveTemplateSubtype(
  page: { pageSubtype?: string },
  archive?: ResolveTemplateSubtypeArchiveInput
): PersonalPageSubtype | undefined {
  if (isPersonalPageSubtype(page.pageSubtype)) {
    return page.pageSubtype;
  }

  if (archive) {
    return parseArchivePersonalPageType(archive.personalPageType, archive.archiveType);
  }

  return undefined;
}

export function resolveEffectiveSubtype(page: {
  pageSubtype?: string | undefined;
  registrationType?: 'form' | 'tickets';
}): PersonalPageSubtype | undefined {
  if (!isPersonalPageSubtype(page.pageSubtype)) {
    return undefined;
  }
  if (
    (page.pageSubtype === 'choiceDonation' || page.pageSubtype === 'choiceEvent') &&
    page.registrationType !== undefined
  ) {
    return resolveChoiceSubtype(page.pageSubtype, page.registrationType);
  }

  return page.pageSubtype;
}
